<template>
  <div class="isoManagementBox">
    <div class="isoManagement">
      <div class="isoManagement-left">
        <el-tree ref="dicTree" class="dicTree" :data="isoTreeList" highlight-current node-key="id" :props="defaultProps" default-expand-all @current-change="currentDicChange">
          <template #default="{ data }">
            <span :title="data.name" class="span-ellipsis">
              <span style="font-size: 14px">
                {{ data.name }}
              </span>
            </span>
          </template>
        </el-tree>
      </div>
      <div class="isoManagement-right">
        <template v-show="activeName === 'index'">
          <div class="right_top">
            <div class="right_top_approveSearch">
              <approveSearch
                ref="approveSearch"
                :showflow-type-select="showflowTypeSelect"
                :keywords-placeholder="'请输入标题/内容'"
                :show-spec-id-select="false"
                @change="handleSearch"
              />
            </div>
          </div>
          <div class="tableList">
            <div v-if="batchDownloadShow" class="operations">
              <el-button type="primary" size="small" :disabled="multipleSelection.length === 0" @click="batchDownload"> 批量下载 </el-button>
            </div>
            <el-table
              ref="isoTable"
              v-loading="loading"
              height="100%"
              size="small"
              :data="isoTable"
              border
              highlight-current-row
              element-loading-text="拼命加载中"
              row-key="flowBusinessId"
              @selection-change="handleSelectionChange"
            >
              <template slot="empty">
                <img :src="zanwu" alt="" />
                <p style="font-size: 16px; color: #000; margin-top: 36px">暂无数据</p>
              </template>
              <el-table-column type="selection" width="55" align="center" reserve-selection />
              <el-table-column type="index" label="编号" align="center" width="60" />
              <el-table-column label="标题" prop="title" min-width="120px" align="center">
                <template #default="{ row }">
                  <el-link type="primary" @click="flowLook(row, 'view')">
                    <span class="tabLinkSpan" :title="row.title">{{ row.title }}</span>
                  </el-link>
                </template>
              </el-table-column>
              <el-table-column label="流程类型" prop="flowType" min-width="80px" align="center" />
              <el-table-column label="内容" prop="content" min-width="100px" show-overflow-tooltip align="center" />
              <el-table-column label="所属项目" prop="prjName" min-width="100px" show-overflow-tooltip align="center" />
              <el-table-column label="申请时间" prop="flowInstanceStartTime" min-width="100px" show-overflow-tooltip align="center" />
              <el-table-column label="申请人" prop="flowInstanceOwnerName" min-width="100px" align="center" />
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-dropdown v-if="scope.row.status === 1 && scope.row.printTemplateFileId" @command="handleDownClick(scope.row, $event)">
                    <el-button type="text">成果文件<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="down">下载</el-dropdown-item>
                      <el-dropdown-item command="recreate">重新生成</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="page">
            <el-pagination
              v-if="page.totalCount > 0"
              size="small"
              background
              :current-page="page.pageNo"
              :page-size="page.pageSize"
              :page-sizes="[10, 20, 50, 100]"
              :layout="page.pageLayout"
              :total="page.totalCount"
              @current-change="familyChangeData"
              @size-change="handleSizeChange"
            />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import approveSearch from "@/CommonDP/pages/mainMg/project/approvalFlow/components/approveSearch";
import flowService from "@/CommonDP/service/flow-service";
import isoManagementService from "@/CommonDP/service/isoManagement-service";
import { getDownloadDesignTemplateInfo } from "@/CommonDP/service/listFlow-service";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
import { openFlow } from "@/CommonDP/components/processComponents/flowNew/index.js";
import { downloadFileShowPrompt, decodeFileName } from "@/CommonDP/utils";
export default {
  name: "IsoManagement",
  components: { approveSearch },
  data() {
    return {
      batchDownloadShow: checkPermission(this.$allPerms.ISOMANAGEMENT_BATCHDOWNLOAD),
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      isoTreeList: [],
      defaultProps: {
        label: "name",
        children: "flowDefinitionDtoList"
      },
      isoTable: [],
      page: {
        pageNo: 1,
        pageSize: 20,
        totalCount: 0,
        pageLayout: "total, sizes,prev, pager, next, jumper" // 分页组件
      },
      approvalProjectList: [],
      definitionList: [],
      userList: [],
      current: {},
      form: {
        flowInstanceOwnerId: "",
        approveTime: "",
        flowType: "",
        keywords: "",
        prjId: ""
      },
      showflowTypeSelect: true,
      loading: false,
      multipleSelection: [],
      activeName: ""
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      prjId: (state) => state.projectMg.prjObj.prjId,
      userInfo: (state) => state.user.userInfo,
      activeNames: (state) => state.enterprise.activeName
    })
  },
  watch: {
    activeName(val) {
      this.$store.dispatch("setActiveName", val);
    }
  },
  mounted() {
    this.activeName = this.activeNames || "index";
    this.getIsoTree();
    this.getIsoList();
  },
  methods: {
    async getIsoTree() {
      const res = await flowService.queryGroupInfoList(this.enterpriseId);
      const allData = [
        {
          id: "",
          name: "全部流程",
          flowDefinitionDtoList: {}
        }
      ];
      res.data.map((item) => {
        this.$set(item, "id", item.flowGroupDto.id);
        this.$set(item, "name", item.flowGroupDto.name);
        this.$set(item, "isType", true);
      });
      allData[0].flowDefinitionDtoList = res.data;
      this.isoTreeList = allData;
      this.$nextTick(() => {
        this.$refs.dicTree.setCurrentKey("");
      });
    },
    // 选中目录树
    currentDicChange(val, node) {
      this.current = val;
      if (val.id === "") {
        this.showflowTypeSelect = true;
      } else {
        this.showflowTypeSelect = false;
      }
      this.isoTable = [];
      this.page.pageNo = 1;
      this.$refs.isoTable.clearSelection();
      this.getIsoList();
    },
    // 族表格分页点击
    familyChangeData(val) {
      this.page.pageNo = val;
      this.getIsoList();
    },
    // 分页
    handleSizeChange(val) {
      this.page.pageNo = 1;
      this.page.pageSize = val;
      this.getIsoList();
    },
    handleSearch(form) {
      this.page.pageNo = 1;
      this.form = {
        ...form
      };
      this.getIsoList();
    },
    async getIsoList() {
      this.loading = true;
      try {
        const { flowInstanceOwnerId, approveTime, flowType, keywords, prjId } = this.form;
        const {
          page: { pageNo, pageSize },
          enterpriseId
        } = this;

        const params = {
          enterpriseId,
          keywords,
          prjId,
          flowType: "",
          groupId: "",
          flowInstanceOwnerId,
          startDate: approveTime ? approveTime[0] : "",
          endDate: approveTime ? approveTime[1] : ""
        };
        if (this.showflowTypeSelect) {
          params.flowType = flowType;
          params.groupId = "";
        } else {
          params.flowType = this.current.isType ? "" : this.current.id;
          params.groupId = this.current.isType ? this.current.id : this.current.groupId;
        }
        const { data, pageIndex, totalCount } = await isoManagementService.isoManagePageList(params, pageNo, pageSize);
        this.isoTable = data;
        this.page.pageNo = pageIndex;
        this.page.totalCount = totalCount;
      } finally {
        this.loading = false;
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    batchDownload() {
      const rows = this.multipleSelection.filter((item) => item.status === 1 && item.printTemplateFileId);
      console.log(this.multipleSelection.filter((item) => item.status === 1).length);
      if (rows.length) {
        this.multipleSelection.map((item) => {
          this.flowDown(item);
        });
      } else {
        this.$warn("您当前选中的流程尚未完成在线打印设计！请去流程设置中完成打印设计操作！");
      }
    },

    handleDownClick(row, command) {
      switch (command) {
        case "down":
          this.flowDown(row);
          break;
        case "recreate":
          this.recreateDesignFile(row);
          break;
      }
    },

    async flowDown(item) {
      const response = await getDownloadDesignTemplateInfo(item.flowInstanceId);
      const fileName = decodeFileName(response.getHeaders()["content-disposition"]);
      downloadFileShowPrompt(fileName, response);
    },

    async recreateDesignFile(item) {
      await this.$confirm(`确认重新生成成果文件吗？`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      this.$success("生成中请稍候，完成后将自动下载成果文件");
      const res = await flowService.recreateDesignFile(item.flowInstanceId);
      // this.$success("成果文件已生成，准备下载");
      item.printTemplateFileId = res.data?.fileId;
      item.printResultFileVersion = res.data?.fileVersion;
      this.flowDown(item);
    },

    async flowLook(row, approveType) {
      const { currentVersionId = "", flowInstanceId = "", flowKey, businessId = "", startMode } = row;
      const data = { currentVersionId, flowInstanceId, flowKey, approveType, businessId, enterpriseId: this.enterpriseId, isProject: this.isProject };
      // 新窗口打开
      if (startMode === "stdNew") {
        const routeUrl = this.$router.resolve({ path: "/examine-new", query: data });
        window.open(routeUrl.href, "_blank");
      } else {
        await openFlow(data);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.isoManagementBox {
  width: 100%;
  height: 100%;
  padding: var(--middle-space);
  .isoManagement {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-color: #eff1f6;
    flex: 1;
    display: flex;
    overflow: hidden;
  }
  .isoManagement-left {
    overflow: hidden;
    padding-top: var(--middle-space);
    display: flex;
    flex-direction: column;
    width: 264px;
    border-right: 1px solid #f2f2f2;
    background-color: #fff;
    .dicTree {
      overflow: hidden;
      flex: 1;
      font-size: 14px;
      &:hover {
        overflow: auto;
      }
      img {
        margin-right: 6px;
      }
      .span-ellipsis {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: flex;
        align-items: stretch;
      }
    }
  }
  .isoManagement-right {
    overflow: hidden;
    flex: 1;
    border-right: 1px solid #f2f2f2;
    display: flex;
    flex-direction: column;
    margin-left: var(--middle-space);
    background-color: #fff;
    .right_top {
      padding: 0px var(--big-space);
      border-bottom: 1px solid #e5e8f1;
      display: flex;
      align-items: flex-start;
      .right_top_approveSearch {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
      }
    }
    .tableList {
      flex: 1;
      overflow: hidden;
      padding: var(--middle-space) var(--big-space) 0;
      display: flex;
      flex-direction: column;
      .operations {
        float: left;
        margin-bottom: var(--middle-space);
      }
    }
    .page {
      width: 100%;
      padding: var(--middle-space) var(--big-space);
      .el-pagination {
        float: right;
      }
    }
  }
  .page {
    display: flex;
    justify-content: flex-end;
  }
  .span-ellipsis {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
